import { CredentialProvider, User, UserRole, UserSettings } from '@modules/core/types';

export const MOCK_CURRENT_USER: User = {
  id: '1',
  status: '',
  created: '',
  activated: null,
  lastLogin: null,
  lastUpdated: null,
  passwordChanged: null,
  credentials: {
    password: {},
    provider: {
      name: CredentialProvider.OKTA,
      type: CredentialProvider.OKTA,
    },
  },
  profile: {
    email: 'user@test.com',
    firstName: 'FirstName',
    lastName: 'LastName',
    pp_role: UserRole.ADMINISTRATOR,
  },
};

export const MOCK_GROUPS = [
  { id: 'admin', profile: { name: 'partner-experience:helix:administrator' } },
  { id: 'member', profile: { name: 'partner-experience:helix:non-administrator' } },
];

export const MOCK_USER_SETTINGS: UserSettings = {
  acceptedTerms: true,
  userId: '1',
};
